import { RiUserLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";

const TopNavigation = () => {
  const location = useLocation();
  return (
    <nav className="fixed top-0 left-0 right-0 bg-gray-800 py-4 px-8 flex items-center justify-between z-[5]">
      {/* Logo */}
      <div className="flex items-center">
        {/* <img src={logo} alt="logo" className="w-8 h-8" /> */}
        <h1 className="text-white text-sm sm:text-base ml-2 font-bold tracking-wide logo">
          Foodie
        </h1>
      </div>

      {/* React Icon */}
      <div className="flex items-center">
        <Link
          to="/user-profile"
          className={`flex flex-col items-center text-gray-600 hover:text-gray-900 ${
            location.pathname === "/user-profile" ? "font-bold" : ""
          }`}
        >
          <RiUserLine
            className="text-white text-2xl cursor-pointer"
            size={26}
          />
        </Link>
      </div>
    </nav>
  );
};

export default TopNavigation;
